// Presentation-only config for the vendor Business Dashboard tab. Every export here is styling
// (labels, icons, colors) that a card is dressed in — the actual numbers always come from the api.

// Palette used across the business dashboard cards. Kept in one place so the charts and the
// cards never drift apart.
export const BUSINESS_DASHBOARD_COLORS = {
    indigo: "#5D5FEF",
    green: "#03B675",
    greenAlt: "#51B850",
    amber: "#FE9D0B",
    red: "#FD3757",
    blue: "#1B9CFC",
    grey: "#67768E",
    track: "#F1F5F9",
}

// Row 1 : the four sales summary cards. `qtyField`/`amountField` name the SALES_KPI_SUMMARY
// resource fields each card reads from.
export const SALES_SUMMARY_CARDS = [
    { id: "last30", title: "Last 30 Days Sales", icon: "shoppingBag", iconBg: "#03B675", qtyField: "last_30_days_sales_qty", amountField: "last_30_days_sales_amount" },
    { id: "mtd", title: "MTD Sales", icon: "barChart", iconBg: "#03B675", qtyField: "mtd_sales_qty", amountField: "mtd_sales_amount" },
    { id: "last365", title: "Last 365 Days Sales", icon: "pieChart", iconBg: "#51B850", qtyField: "last_365_days_sales_qty", amountField: "last_365_days_sales_amount" },
    { id: "ytd", title: "YTD Sales", icon: "rupee", iconBg: "#1B9CFC", qtyField: "ytd_sales_qty", amountField: "ytd_sales_amount" },
]

// Row 2 : the sell through buckets inside the "Sales Overview" card. `category` matches the
// `performance_category` value the SALES_OVERVIEW_SUMMARY api returns, everything else here is
// presentation only (the numbers come from the api).
export const SELL_THROUGH_SEGMENT_STYLES = [
    { id: "hero", category: "Hero Products", subTitleColor: "#16A34A", background: "#E6F8F2", border: "#03B675" },
    { id: "high", category: "High Performers", subTitleColor: "#16A34A", background: "#F6FBF6", border: "" },
    { id: "above", category: "Above Average", subTitleColor: "#FE9D0B", background: "#FFFAF3", border: "" },
    { id: "below", category: "Below Average", subTitleColor: "#FE9D0B", background: "#FFF6E7", border: "" },
    { id: "low", category: "Low Performers", subTitleColor: "#FD3757", background: "#FFF5F6", border: "" },
    { id: "risk", category: "High Risk Inventory", subTitleColor: "#FD3757", background: "#FFEBEF", border: "" },
]

// Row 3 : "GRC Received" group. `qtyField`/`amountField` name the GRC_KPI_SUMMARY resource
// fields each card reads from.
export const GRC_RECEIVED_CARDS = [
    { id: "totalGrc", label: "Total GRC", icon: "grc", qtyField: "total_grc_qty", amountField: "total_grc_amount" },
    { id: "grc30", label: "GRC (last 30 Days)", icon: "grc", qtyField: "last_30_days_grc_qty", amountField: "last_30_days_grc_amount" },
    { id: "grc365", label: "GRC (last 365 days)", icon: "grc", qtyField: "last_365_days_grc_qty", amountField: "last_365_days_grc_amount" },
]

// The fulfillment tile inside "GRC Received". value/percentage/pendingAmount are computed from
// the PO_GRC_KPI_SUMMARY api (fulfillment_rate, pending_amount) at render time.
export const GRC_FULFILLMENT_LABELS = {
    title: "GRC fulfillment %",
    pendingLabel: "pending Amount",
}

// Row 3 : "Transaction Details" group
export const TRANSACTION_DETAIL_CARDS = [
    { id: "outstanding", label: "Total Outstanding", icon: "pending", bg: "bg-[#fafafa]" },
    { id: "due7", label: "Due in next 7 days", icon: "clock" },
    { id: "due15", label: "Due in next 15 days", icon: "clock" },
    { id: "due30", label: "Due in next 30 days", icon: "clock" },
]

export const EARLY_PAYMENT_SUMMARY = [
    { id: "requested", label: "Total Amount Requested", type: "icon", icon: "send", iconBg: "#5D5FEF" },
    { id: "processed", label: "Processed Amount", type: "icon", icon: "checkCircle", iconBg: "#03B675" },
    { id: "eligible", label: "Eligible Invoices", type: "stat", background: "#F1F0FF", valueColor: "#5D5FEF" },
    { id: "discount", label: "Avg Discount Offered", type: "stat", background: "#EAFBF1", valueColor: "#03B675" },
]
